import React from 'react';

/** Utility function for AppSplashDialogs hooks to check if the dialog has been shown
 * @param show - The boolean value to check if the dialog has been shown
 * @returns A boolean value indicating if the dialog has been shown
 */
export const useHasShown = (show: boolean) => {
  const [hasShown, setHasShown] = React.useState(show);
  React.useEffect(() => {
    if (show) {
      setHasShown(true);
    }
  }, [show]);
  return hasShown;
};
